var generateStyle = function generateStyle() {
  return {
    picker: {
      paddingLeft: '1rem'
    }
  };
};
export default generateStyle;